export default __webpack_public_path__ + "static/carousel1-ecefe4c2b6cae4d023fbf07cc5a6ed1d.webp";